import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>அக்னி ஸந்தானம்</h1>
  <div class="title3">அக்னிஸந்தானம் ஒளாபஸனம் வீடியோ</div>
  <ion-item>
    <div class="video-container">
      <iframe src="https://www.youtube.com/embed/Os7ewR_zu2M?rel=0" frameborder="0" width="300" height="169"></iframe>
    </div>
    </ion-item>
  <div class="div3">
    இந்தப் பகுதி படங்கள், குறிப்புகள், மந்திரங்கள் ஸம்ஸ்க்ருதத்தில் 
    இணைத்து மேம்படுத்தப்படவேண்டும். உபாகர்மா நெருங்குவதால்
    தயாரானவரை அப்படியே வழங்கப்பட்டுள்ளது. 
    தேவையான இடங்களில் ஆடியோவும் இணைக்க உத்தேசம். 
    தவறுகள் கூட இன்னும் சரிபார்க்கப்படவில்லை.
    எனவே தற்போதைக்கு அக்னிஸந்தான, ஔபாஸன ப்ரயோகங்களை 
    உபயோகிக்கவேண்டாம் என விண்ணப்பித்துக்கொள்கிறோம்.  
    <hr class="orange">
    அமாவாசை தர்பணமும் - நித்யமும் தானியங்கி முறையில் 
    ஸங்கல்பம் ஆடியோவடிவில் வழங்கவும் நடவடிக்கை மேற்கொள்ளப்பட்டு 
    வருகிறது. 

  </div>
  <mat-accordion>
    <mat-expansion-panel>
              <mat-expansion-panel-header>01. அனுஜ்ஞை
          </mat-expansion-panel-header>
     <div class="div3">
      பவித்ரம் த்ருத்வா! பத்ந்யாஸ: தாம்பூல தக்ஷிண அக்ஷதாநு க்ருஹீத்வா! ஹரி: ஓம் நமஸ்ஸதஸே நமஸ்ஸதஸ: பதயே நம: ஸகீநாம் ப்ரோகாணாம் க்ஷக்ஷுஸே நமோதிவே நம:ப்ருத்வ்யை ஸப்ரதா ஸபாம்மே கோபாயா யேசஸப்யா: ஸபாஸத: தாநு இந்திரியாவத: குரு ஸர்வமாயு: உபாஸதாம் ஸர்வேப்ய: ஸ்ரீவைஷ்ணவேப்யோ நம: இதி ப்ராஹ்மணாநு அப்யர்ச்சயா! நமஸ்க்ருத்யா!
      தக்ஷிணாம் தாம்பூலஞ்ச க்ருஹீத்வா! ஸ்வாமிந: பவத்பாதமூலே மயா ஸமர்ப்பிதாம் இமாம் சௌவர்ணீம் தக்ஷிணாம் யத்கிஞ்சிது தக்ஷிணாம் யதோக்த தக்ஷிணாமிவ ஸ்வீக்ருத்யா! ஆவயோ: அநேககால விச்சின்ன ஒளபாஸன அக்நிஸந்தானம் கர்த்தும் யோக்யதா சித்திம் அநுக்ரஹாணா!
     </div>
            
    
    </mat-expansion-panel >
    <mat-expansion-panel>
      <mat-expansion-panel-header>02. ஸங்கல்பம்
 </mat-expansion-panel-header>
<div class="div3">
  தர்பேஷ்ஸ்வாஸீந: தர்பாநு தாராயமாண: பவித்ரபாணி: பத்ந்யா அந்வாரப்த: ப்ராணாநாயம்யா!

  ஓம் அஸ்மத் குருப்யோ நம:
  ( வடகலை ஸம்ப்ரதாயம் : ஸ்ரீமாந் வேங்கட நாதார்ய: கவிதார்க்கிக கேசரி வேதாந்தாச்சார்ய வர்யோமே ஸந்நிதத்தாம் ஸதாஹ்ருதி. குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே வ்ருணீமஹேஸ்ச்சா தத்ராத்யௌ தம்பதீ ஜகதாம்பதீ ஸ்வஷேண பூதேநமயா ஸ்வீயை: ஸர்வ பரிச்சதை: விதாதும் ப்ரீதம் ஆத்மாநம் தேவ: ப்ரக்ரமதே ஸ்வயம்) சுக்லாம்பரதரம் விஷ்ணும் ஸசிவர்ணம் சதுர்புஜம் ப்ரசந்;நவதனம் த்யாயேத் ஸர்வவிக்நோபசாந்தயே!
  யஸ்யத்விரத வக்ராத்யா: பாரிஷத்யா: பரஸ்சதம் விக்நம் நிக்நந்தி ஸததம் விஷ்வக்ஸேநம் தமாச்ரயே!
  ஹரி:ஓம்தது!
  ஸ்ரீகோவிந்தா .... ஷஷ்டி ஸம்வத்ஸராணாம் மத்யே .... நாம ஸம்வத்ஸரே .... அயனே ருதௌ மாஸே பக்ஷே அஸ்யாம் சுப திதௌ .... வாஸர: ... வாஸரயுக்தாயாம் ....... நக்ஷத்ர யுக்தாயாம் ஏவங்குண விசேஷண விசிஷ்டாயாம் அஸ்யாம் ...... சுப திதௌ ஸ்ரீபகவது ஆஜ்ஞயா ................... பகவத் கைங்கர்யம் ஆவயோ: அநேககால விச்சின்ன ஒளபாஸன அக்நி ஸந்தானம் கரிஷ்யே! ஆவயோ: ஒளபாஸன அக்நிம் ஆ தாஸ்யே விச்சின்ன சந்தானார்த்தம்!
  இடுக்குப்பில்லை வடக்கே சேர்க்கவேண்டியது.
  அபஉபஸ்ப்ருஸ்ய!
  (வடகலை மட்டும் பகவாநேவ .... அக்நிஸந்தாநாக்யம் கர்ம ஸ்வஸ்மை .... காரயதி!
</div>
      

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>03. ஸ்தண்டிலம் - பரிஸ்தரணம்
</mat-expansion-panel-header>
<div class="div3">
  ஸ்தண்டிலம் கல்பயித்வா! ப்ராசீ: பூர்வம் உதக்குஸக்குஸ்த்வம் தக்ஷிணாரம்பம் ஆலிகேது.
  அத: உதீசீ: பஸ்சிமாரம்பம் ஆலிகேது! அவாக்கரோப்யுக்ஷ்யா! த்ருணம் நைருருத்யாம் நிரஸ்யா
  அபஉபஸ்பருஸ்யா! நிதாயவஹ்நிம்! உத்சித்ச்யதே அவோக்ஷண தோயசேஷம் ப்ராக்தோயம் அந்யது.
  நிததாதி உதக்வா. யதாபஹி: ஸ்யாஸ்ச்ச பரிஸ்தராணாம் அக்நே: ப்ராகாதி ப்ரதக்ஷிணம் பரிஸ்தீர்யா!
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>04. அக்னி ப்ரதிஷ்டை
</mat-expansion-panel-header>
<div class="div3">
  பூர்புவஸ்ஸுவரோம்! இதி அக்நிம் ப்ரதிஷ்டாப்யா அக்நிமித்வா - அக்நிம் ப்ரஜ்வால்யா!
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>05. பாத்ர ஸம்ஸ்காரம்
</mat-expansion-panel-header>
<div class="div3">
  அக்நேருத்தரத: ப்ராகக்ராநு தர்பாநு ஸக்குஸ்தீர்யா தேஷு தர்வீம் ஆஜ்யஸ்தாலீம் ப்ரோக்ஷணீம் இதர தர்வீம்ஞ்ச சாதயித்வா ஆயாமத: பரீமாணம் ப்ரோக்ஷணீ ஸக்குஸ்கார: ப்ரோக்ஷணீ பாத்ரமாதாயா.
  அத்பி: பூரயித்வா.
  உதகக்ராப்யாம் பவித்ராப்யாம் திரி: ப்ராக் உத்பூயா
  உத்தாநாநி பாத்ராணி க்ருத்வா. ஸர்வாபி: அத்பி: திரி:ப்ரோக்ஷயா.
  அந்யஜ்ஜலம் பூரயித்வா. ப்ரோக்ஷணீ பாத்ரம் தக்ஷிணதோ நிதாயா.
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>06.ஆஜ்ய ஸம்ஸ்காரம்
</mat-expansion-panel-header>
<div class="div3">
  பவித்ராம் அந்தர்ஹிதாயாம் ஆஜ்யஸ்தால்யாம் ஆஜ்யம் நிரூப்யா. உதீச: அங்காராநு நிரூஹ்யா.
  தேஷு அதிச்ருத்யா. ஜ்வலதா த்ருணேநா அவதுத்யா. த்வே தர்பாக்ரே ப்ரச்சித்யா. ப்ரக்ஷாள்யா
  ஆஜ்யபாத்ரே ப்ரத்யஸ்யா. திரி: பர்யக்நி க்ருத்வா. உதக்குத்வாஸ்யா.
  அங்காராநு அக்நௌ ப்ரத்யூஹ்யா. ஆஜ்யபாத்ரம் புரதோ நிதாயா!
  உதகக்ராப்யாம் பவித்ராப்யாம் புந: ஆஹாரமாஜ்யம் திரி: உத்பூயா.
  பவித்ர க்ரந்திம் விஸ்ருஸ்யா! அபஉபஸ்ப்ருஸ்ய. ப்ராகக்ரமக்நௌ ப்ரஹரதி.
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>07. தர்வீ ஸம்ஸ்காரம்
</mat-expansion-panel-header>
<div class="div3">
  யேநஜுஹோதி. ததக்நௌ ப்ரதிதப்யா. தர்பை: ஸம்ருஜ்யா. புந: ப்ரதிதப்யா. ப்ரோக்ஷ்யா.
  தர்வ்யௌ நிதாயா. தர்பாநு அத்பி: ஸக்குஸ்பர்ஸ்யா. அக்நௌ ப்ரஹரதி.
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>08. பரிஷேசனம்
</mat-expansion-panel-header>
<div class="div3">
  அத: பரிஷேசனம்.
  ஓம் அதிதே அநுமந்யஸ்வா
  அநுமதே அநுமந்யஸ்வா
  ஸரஸ்வதே அநுமந்யஸ்வா
  தேவ ஸவித: ப்ரஸுவா!
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>09. ப்ரதான ஆஹுதி
</mat-expansion-panel-header>
<div class="div3">
  ப்ரதாந தர்வ்யாம் சதுர்க்ருஹீதம் ஆஜ்யம் க்ருஹீத்வா!
  ஓம் பூர்புவஸ்ஸுவ ஸ்வாஹா!
  ப்ரஜாபதயே இதம் நமமா!
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>10. அயாஸ்ச ஹோமம்
</mat-expansion-panel-header>
<div class="div3">
  அபஉபஸ்ப்ருஸ்யா !<br>
  ப்ரணாநாயம்யா!<br>
  ஸ்ரீ - ம் ஆவயோ: பூர்வேத்யு: உபவாசஸ்தாநே அயாஸ்ச்ச ஹோமம் கரிஷ்யே!<br>
  1. அயாஸ்ச்சா அக்நேஸி அநபிசஸ்தீஸ்ச்சா ஸத்யமித்வம் அயாஅஸி அயஸா மநஸா த்ருத: அயஸா ஹவ்யமூஹிஷே அயாந: தேஹி பேஷஜம் ஸ்வாஹா!
  <br>அக்நயே அயஸே இதம் நமமா1<br>
  2. புநஸ்த்வா ஆதித்யா: ருத்ரா: வஸவ: ஸமிந்ததாம் புந: ப்ரம்ஹாண: வஸுநீதா யஜ்ஞை: க்ருதேநத்வம் தநுவ: வர்த்தயஸ்வா ஸத்யாஸ்சந்து யஜமாநஸ்ய காமா: ஸ்வாஹா
  <br>ஆதித்யாhய இதம் நமமா<br>
  3. மந: ஜ்யோதி: ஜுஷதாம் ஆஜ்யம் விச்சின்னம் யஞ்ஞம் ஸமிமம் ததாது யாஇஷ்டா: உஷஸ: நிம்ருச்சஸ்ச்சா தாஸ்ஸந்ததாமி ஹவிஷா க்ருதேந ஸ்வாஹா!
  <br>மநஸே ஜ்யோதிஷே இதம் நமமா!<br>
  4. யந்மே ஆத்மந: மிந்தாபூது அக்நிஸ்தது புநராஹா: ஜாதவேதர்: விசர்ஷணி: ஸ்வாஹா!
  <br>அக்நயே ஜாதவேதஸே இதம் நமமா1<br>
  5. புநரக்நி: க்ஷக்ஷுரதாது புநரிந்த்ர: ப்ருஹஸ்பதி: புநர்மே அஸ்விநாயுவம் சக்ஷுராதத்தம் அக்ஷயோ ஸ்வாஹா!
  <br>அக்நீ இந்த்ரா ப்ருஹஸ்பதி அஸ்விப்ய: இதம் நமமா!<br>
  6.தந்துந்தந்வந்நு ரஜஸ: பாநும் அந்வி: ஜ்யோதிஷ்மத: பதோரக்ஷ த்யாக்ருதாநு அநுல்பணம் வயத ஜோகுவாம் அப: மநுர்பவா ஜநயா தைவ்யம் ஜநம் ஸ்வாஹா!
  <br>அக்நயே தந்துமதே இதம் நமமா1<br>
  ஓம் பூஸ் ஸ்வாஹா - <br>அக்நயே இதம் நமமா!<br>
  ஓம் புவஸ் ஸ்வாஹா -<br> வாயவே இதம் நமமா!<br>
  ஓம் ஸுவஸ் ஸ்வாஹா -<br> சூர்யாய இதம் நமமா!<br>
  ஓம் பூர்புவஸ்ஸுவஸ்ஸ்வாஹா!<br>
  ப்ரஜாபதயே இதம் நமமா!
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>11. அகரண ப்ராயச்சித்தாதிகள்
</mat-expansion-panel-header>
<div class="div3">
  அப உபஸ்ப்ருஸ்யா!<br>
  ப்ராணாநாயம்யா!<br>
  ஸ்ரீ-ம். ஆவயோ: அநேககால ஸாயம் ப்ராத: ஆஹுதீநாம் அகரண ப்ராயஸ்ச்சித்தார்த்தம் ஸர்வ ப்ராயஸ்ச்சித்த ஹோமம் ஹோஷ்யாமி.<br>
  ஓம் பூர்புவஸ்ஸுவஸ்ஸ்வாஹா!<br>
  ப்ரஜாபதயே இதம் நமமா!<br>
  அபஉபஸ்ப்ருஸ்யா!<br>
  ப்ராணாநாயம்யா!<br>
  ஸ்ரீ-ம் ஆவயோ: அநேக தர்ச பூர்ணமாஸ ஸ்தாலீபாக அகரண ப்ராயஸ்ச்சித்தார்த்தம் ஸர்வ ப்ராயஸ்ச்சித்த ஹோமம் ஹோஷ்யாமி.<br>
  ஓம் பூர்புவஸ்ஸுவஸ்ஸ்வாஹா!<br>
  ப்ரஜாபதயே இதம் நமமா!
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>12. மந்த்ர - தந்த்ர ப்ராயச்சித்தம் 
</mat-expansion-panel-header>
<div class="div3">
  அபஉபஸ்ப்ருஸ்யா!<br>
  ப்ராணாநாயம்யா|<br>
  ஸ்ரீ-ம். ஆவயோ: அஸ்மிந்நு விச்சின்ன ஒளபாஸன அக்நி ஸந்தாந ஹோம கர்மணி மத்யே ஸம்பாவித மந்த்ர தந்த்ர ஸ்வரவர்ண விதிவிபர்யாஸ ந்யுநாதிரித்த ப்ராயஸ்ச்சித்தார்த்தம் ப்ராயஸ்ச்சித்த ஆஹுதீ: ஹோஷ்யாமி!<br>
  ஓம் பூர்புவஸ்ஸுவஸ்ஸ்வாஹா!<br>
  ப்ரஜாபதயே இதம் நமமா!<br>
  1. அநாஆஞ்ஞாதம் யதாஜ்ஞாதம் யஜ்ஞஸ்ய க்ரியதே மிது அக்நே ததஸ்யா கல்பயா த்வகும்ஹி வேத்தா யதாததம் ஸ்வாஹா!
  <br>அக்நயே இதம் நமமா!<br>
  2. புருஷஸம்ஹித: யஜ்ஞ: யஜ்ஞ: புருஷஸம்ஹித: அக்நே ததஸ்யா கல்பயா த்வகும்ஹி வேத்தா யதாததம் ஸ்வாஹா!
  <br>அக்நயே இதம் நமமா!<br>
  3. யத்பாகத்ரா: மநஸா தீநதக்ஷாணா யஜ்ஞஸ்யா மந்வதே மர்த்தாஸ: அக்நிஸ்தது ஹோதா க்ரதுவிது விஜாநந்நு யஜிஷ்ட: தேவாநு ருதுச: யஜாதி ஸ்வாஹா!
  <br>அக்நயே இதம் நமமா!<br>
  4. த்வந்ந: அக்நே வருணஸ்ய வித்வாநு தேவஸ்யா ஹேட: அவ யாஸிஸீஷ்டா: யஜிஷ்ட: வஹ்நிதம: சோசுசாந: விஸ்வா த்வேஷாகும்ஸி ப்ரமுமுக்தி அஸ்மது ஸ்வாஹா!
  <br>அக்நீ வருணாப்யாம் இதம் நமமா!<br>
  5. ஸத்வந்ந: அக்நே அவம: பவோதீ நேதிஷ்ட: அஸ்யா: உஷஸ: வ்யுஷ்டௌ அவயக்ஷ்வண: வருணம் ரராண: வீஹி ம்ருடீகம் ஸுஹவ: நயேதி ஸ்வாஹா!
  <br> அக்நீ வருணாப்யாம் இதம் நமமா!<br>
  6. ஆபி: கீர்பி: யததோந: ஊநம் ஆப்யாயயா ஹரிவ: வர்த்தமாந: யதா ஸ்தோத்ருப்ய: மஹி கோத்ரா ருஜாஸி பூயிஷ்டபாஜ: அததே ஸ்யாமா ஸ்வாஹா!
  <br>இந்த்ராய ஹரிவதே இதம் நமமா!<br>
  7. இதம் விஷ்ணு: விசக்ரமே த்ரேதா நிததே பதம் ஸமூடமஸ்யா பாகும்சுரே ஸ்வாஹா!
  <br>விஷ்ணவே இதம் நமமா!<br>
  8. ஓம் பூஸ் ஸ்வாஹா -<br> அக்நயே இதம் நமமா!<br>
  9. ஓம் புவஸ் ஸ்வாஹா -<br> வாயவே இதம் நமமா!<br>
  10. ஓம் ஸுவஸ் ஸ்வாஹா -<br> சூர்யாய இதம் நமமா!<br>
  11. ஓம் பூர்புவஸ்ஸுவஸ்ஸ்வாஹா!<br>
  ப்ரஜாபதயே இதம் நமமா!<br>
  ப்ராணாநாயம்யா!<br>
  (தென்கலையார் மட்டும்) ஸ்ரீ-ம் கர்ம சாத்குண்யார்த்தம் கேஸவாதி ஹோமம் கரிஷ்யே!<br>
  ஓம் கேஸவாய ஸ்வாஹா -<br> கேஸவாய இதம்<br>
  ஓம் நாராயணாய ஸ்வாஹா -<br> நாராயணாய இதம்<br>
  ஓம் மாதவாய ஸ்வாஹா -<br> மாதவாய இதம்<br>
  ஓம் கோவிந்தாய ஸ்வாஹா -<br> கோவிந்தாய இதம்<br>
  ஓம் விஷ்ணவே ஸ்வாஹா -<br> விஷ்ணவே இதம்<br>
  ஓம் மதுசூதநாய ஸ்வாஹா - <br>மதுசூதநாய இதம்<br>
  ஓம் த்ரிவிக்ரமாய ஸ்வாஹா -<br> த்ரிவிக்ரமாய இதம்<br>
  ஓம் வாமநாய ஸ்வாஹா - <br>வாமநாய இதம்<br>
  ஓம் ஸ்ரீதராய ஸ்வாஹா -<br> ஸ்ரீதராய இதம்<br>
  ஓம் ருஷீகேஸாய ஸ்வாஹா -<br> ருஷீகேஸாய இதம்<br>
  ஓம் பத்மநாபாய ஸ்வாஹா - <br>பத்மநாபாய இதம்<br>
  ஓம் தாமோதராய ஸ்வாஹா - <br>தாமோதராய இதம்<br>
  ஸர்வம் ஸ்ரீவிஷ்ணவே ஸ்வாஹா<br>
  ஸ்ரீ விஷ்ணவே பரமாத்மநே இதம் நமமா!<br>
  ஆஜ்ய பாத்ரம் உத்தரதோ நிதாயா!<br>
  
  அப உபஸ்ப்ருஸ்யா !<br>
  ப்ராணாநாயம்யா!<br>
  பரிஷேசனம்.<br>
  ஓம் அதிதே அந்வமக்குஸ்தா:<br>
  ஓம் அநுமதே அந்வமக்குஸ்தா:<br>
  ஓம் ஸரஸ்வதே அந்வமக்குஸ்தா:<br>
  தேவஸவித: ப்ராஸாவீ: !
</div>
  

</mat-expansion-panel >
<mat-expansion-panel>
<mat-expansion-panel-header>13. குறிப்பு
</mat-expansion-panel-header>
<div class="div3">
  அக்னி ஸந்தானம் என்பது, நித்ய கர்மாவில் சேராது. 
  ஔபாஸனம் மட்டுமே நித்ய கர்மா ஆகும். 
  நித்யகர்மாவான, ஔபாஸனத்தை தொடர்ந்து சில தினங்கள் 
  (எத்தனை தினங்கள் என்பதில் கருத்து வேறுபாடு உள்ளது),
  செய்யாமல் விட்டுப்போனால், அக்னி தொடச்சி விட்டுப்போகிறது,
  எனவே அக்னி விச்சித்திக்கு பரிஹாரமாகவே அக்னிஸந்தானம் என்கிற இந்த கர்மா 
  விதிக்கப்பட்டுள்ளது. நித்ய ஔபாஸனம் செய்து வருவோருக்கு இதுவரை தேவையில்லை,
  மற்ற அனைவரும் இந்த விச்சின்ன அக்னி ஸந்தானத்தைச் செய்துகொண்டு தொடர்ந்து 
  ஔபாஸனம் என்கிற தலைப்பில் உள்ள கர்மாவைச் செய்யவேண்டும். 
</div>
</mat-expansion-panel>
    </mat-accordion>`;

const AgnisanthanamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="அக்னிஸந்தானம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AgnisanthanamPage;
